module.exports = __webpack_public_path__ + "61cb14ffcaa4038bc3d9a00d5de21281.png";